 <template>
    <div>
            <v-row>
                <v-col cols="12">
                    <div>
                        <div class="headline" v-if="id == 0">Neue Tourvorlage anlegen</div>
                        <div class="headline" v-else>Tourvorlage bearbeiten</div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card class="mb-4">
                        <v-card-text>
                            <v-row>
                                <v-col cols="3">
                                  <v-text-field label="Nummer" v-model="editedItem.identifier"></v-text-field>
                                  <v-text-field v-model="editedItem.max_weight" label="Maximale Auslastung" v-on:change="checkMaxWeight()"></v-text-field>
                                  <v-text-field label="Name" v-model="editedItem.name"></v-text-field>
                                  <v-text-field label="Farbe" v-model="editedItem.color"></v-text-field>
                                  <v-select v-on:change="checkMaxWeight()"
                                    :items="vehicles"
                                    item-value="id"
                                    v-model="editedItem.vehicle"
                                    label="Fahrzeug"
                                  >
                                    <template slot="item" slot-scope="data">
                                      {{ data.item.title }}
                                    </template>
                                    <template slot="selection" slot-scope="data">
                                      {{ data.item.title }}
                                    </template>
                                  </v-select>
                                </v-col>
                              <v-col cols="9">
                                <v-select
                                  :items="districts"
                                  item-value="id"
                                  v-model="editedItem.districts"
                                  label="Orte"
                                  multiple
                                  multi-line
                                  chips
                                >
                                  <template slot="item" slot-scope="data">
                                    <span class="pr-4">{{ data.item.cityName }} - {{ data.item.name}}</span>
                                  </template>
                                  <template slot="selection" slot-scope="data">
                                    <v-chip>{{ data.item.cityName }} - {{ data.item.name }}</v-chip>
                                  </template>
                                </v-select>
                              </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                  <v-card-actions>
                    <v-btn v-on:click="save()" color="primary">Speichern</v-btn>
                    <v-btn v-on:click="deleteEntry()" color="warning">Löschen</v-btn>
                    <v-btn v-on:click="back()">Zurück</v-btn>
                  </v-card-actions>
                </v-col>
            </v-row>
    </div>
</template>

<script>
export default {
  name: 'TourTemplateEdit',
  props: ['id'],
  data: () => ({
    tourTemplate: {
      id: 0,
      name: '',
      identifier: 0,
      color: '000000',
      max_weight: 65,
      districts: [],
      vehicle: 0
    },
    editedItem: {
      id: 0,
      name: '',
      identifier: 0,
      color: '000000',
      max_weight: 65,
      districts: [],
      vehicle: 0
    }
  }),
  computed: {
    districts () {
      return this.$store.state.districts.all
    },
    vehicles () {
      return this.$store.state.vehicle.all
    }
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData(this.id)
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  methods: {
    checkMaxWeight () {
      const vehicle = this.vehicles.find(vehicle => vehicle.id === this.tourTemplate.vehicle)
      if (vehicle !== undefined) {
        if (this.tourTemplate.max_weight > vehicle.maxWeight) {
          this.tourTemplate.max_weight = vehicle.maxWeight
          alert('Die maximale Auslastung wurde auf die des Farhzeuges angepasst')
        }
      }
    },
    fetchData (id) {
      if (id > 0) {
        let tourTemplate = this.$store.state.tourTemplate.all.find(element => element.id === id)
        if (undefined !== tourTemplate) {
          this.editedItem = Object.assign({}, tourTemplate)
        }
      }
    },
    save () {
      if (this.id > 0) {
        this.$store.commit('updateTourTemplate', this.editedItem)
      } else {
        this.$store.commit('addTourTemplate', this.editedItem)
      }
      this.$router.push('/tourtemplate')
    },
    back () {
      this.$router.push('/tourtemplate')
    },
    deleteEntry () {
      this.$store.commit('deleteTourTemplate', this.tourTemplate)
      this.$router.push('/tourtemplate')
    },
    getCity (id) {
      return this.$store.state.cities.find(element => element.id === id)
    },
    getCityNames (districts) {
      let cities = []
      if (districts.length > 0) {
        for (let district of districts) {
          let element = this.getCity(district)
          if (cities.indexOf(element.city) === -1) {
            cities.push(element.city)
          }
        }
      }
      return cities
    }
  }
}
</script>

<style scoped lang="scss">
    @import "../scss/settings";
</style>



// WEBPACK FOOTER //
// src/components/TourTemplateEdit.vue